import React from 'react';
import styles from './styles/Page.module.css';

export default function PrivacyFrench() {
  return (
    <>
      <div className={styles.page}>
        <h1 className={styles.page_title}>POLITIQUE DE CONFIDENTIALITE</h1>
        <div className={styles.date}>Version en date du 21/09/2023</div>

        <p>
          Lorsque vous naviguez sur le Site ou utilisez les Services, OSTREON est susceptible de collecter et de traiter vos Données Personnelles.
        </p>

        <p>
          OSTREON porte une attention particulière au respect de votre vie privée et à la protection de vos Données Personnelles.
        </p>

        <p>
          Vos Données Personnelles vous appartiennent et sont traitées par OSTREON de manière transparente, confidentielle et sécurisée.
        </p>

        <p className={styles.title}>
          <strong>
            1. Quel est l’objet de ce document?
          </strong>
        </p>

        <p>
          La présente politique de confidentialité (ci-après la « <strong>Politique de confidentialité</strong> ») a pour objectif de vous informer sur:
          <ul>
            <li>
              les modalités de collecte et les caractéristiques des traitements de vos Données Personnelles mis en œuvre par OSTREON, conformément à la règlementation relative à la protection des Données, notamment le RGPD et la loi n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés modifiée et ses textes d’application, ainsi que tout acte législatif et/ou règlementaire de droit français ou européen applicable en France relatif à la protection des Données Personnelles (ci-après la « <strong>Réglementation applicable en matière de protection des Données Personnelles</strong> ») ;
            </li>
            <li>
              vos droits au regard de la Réglementation applicable en matière de protection des Données Personnelles.
            </li>
          </ul>
        </p>

        <p>
          La Politique de confidentialité fait partie intégrante des <a href="https://ostreon.io/terms-and-conditions">CG</a> et doit être lue conjointement à celles-ci et s’applique à toutes les informations personnelles et données de navigation collectées et traitées à l’occasion de vos contacts avec OSTREON. L’ensemble des termes utilisés avec une majuscule et qui ne sont pas définis dans la Politique de confidentialité ont le sens qui leur est donné dans les CG.
        </p>

        <p>
          OSTREON est susceptible de modifier la Politique de confidentialité à tout moment, notamment afin d’assurer sa conformité aux évolutions législatives et règlementaires. Une information et/ou une demande d’acceptation sera dès lors communiquée à l’Utilisateur si nécessaire via le Site.
        </p>

        <p className={styles.title}>
          <strong>
            2. Qui est responsable du traitement?
          </strong>
        </p>

        <p>
          Les Données Personnelles collectées par l’intermédiaire du Site sont traitées par OSTREON, en qualité de responsable du traitement:
        </p>

        <p className={styles.text_center}>
          <strong>
            OSTREON CYBERSECURITY
          </strong>
          <div>
            Société par actions simplifiée
          </div>

          <div>
            Immatriculée au RCS de Nanterre sous le numéro 920 541 448
          </div>

          <div>
            Siège social sis 13 T rue Auguste Gervais – 92130 Issy-les-Moulineaux, France
          </div>
        </p>

        <p>
          Pour toute question relative à la gestion et à l’utilisation de vos Données Personnelles, vous pouvez adresser un mail à OSTREON à l’adresse suivante: <a href="mailto:">compliance@ostreon.io</a>.
        </p>

        <p className={styles.title}>
          <strong>
            3. Quelles sont les Données Personnelles collectées et traitées par OSTREON?
          </strong>
        </p>

        <p>
          Les catégories suivantes de Données Personnelles sont susceptibles d’être collectées de manière directe et traitées par OSTREON:
        </p>

        <table className={styles.personal_table}>
          <tbody>
            <tr>
              <td>
                <strong>
                  Utilisateur
                </strong>
              </td>
              <td>
                <div>
                  Des données d’identification : nom, prénom;
                </div>
                <div>
                  Des données de contact : e-mail;
                </div>
                <div>
                  Des données de connexion : adresse IP, logs de connexion;
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Clients (abonnement)
                </strong>
              </td>
              <td>
                <div>
                  Des données d’identification : nom, prénom;
                </div>
                <div>
                  Des données de contact : e-mail, adresse postale, numéro de téléphone;
                </div>
                <div>
                  Des informations d’ordre économique et financier à l’exception des Offres d’essai : date et heure du paiement, montant, mode de paiement, formule d’abonnement, statut de paiement, informations de facturation;
                </div>
                <div>
                  Des données de connexion : adresse IP, logs de connexion;
                </div>
                <div>
                  Des données de gestion : historique, réclamations, demandes, messages d'assistance.
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <p>
          Les catégories suivantes de Données Personnelles sont susceptibles d’être collectées de manière indirecte et traitées par OSTREON:
        </p>

        <table className={styles.personal_table}>
          <tbody>
            <tr>
              <td>
                <strong>
                  Facilitateur (y compris le notaire/avocat)
                </strong>
              </td>
              <td>
                <div>
                  Des données d’identification : nom, prénom, date de naissance;
                </div>
                <div>
                  Des données de contact : e-mail, adresse postale, numéro de téléphone.
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Bénéficiaires
                </strong>
              </td>
              <td>
                <div>
                  Des données d’identification : nom, prénom;
                </div>
                <div>
                  Des données de contact : e-mail, adresse postale, numéro de téléphone;
                </div>
                <div>
                  Des données de connexion : adresse IP, logs de connexion;
                </div>
                <div>
                  Des données de gestion : historique, réclamations, demandes, messages d'assistance.
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <p className={styles.title}>
          <strong>
            4. Pour quelles raisons sont collectées et traitées vos Données Personnelles?
          </strong>
        </p>

        <p>
          Vos Données Personnelles collectées et traitées par OSTREON sont utilisées pour:
          <ul>
            <li>
              Gestion de la relation contractuelle, impliquant notamment : la gestion du Compte Utilisateur ; la fourniture des Services ; la prévention des impayés, la facturation, le recouvrement et la gestion du contentieux ; la gestion des réclamations et demandes;
            </li>
            <li>
              Gestion des relations avec les Bénéficiaires;
            </li>
            <li>
              Gestion et réponse aux demandes d’exercice des droits par les personnes concernées;
            </li>
            <li>
              Envoi de newsletters, contenu commercial et publicitaire;
            </li>
            <li>
              Prospection commerciale;
            </li>
            <li>
              Gestion du bon fonctionnement et amélioration du Site et de ses fonctionnalités.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            5. Sur quels fondements juridiques reposent les traitements des Données Personnelles des Utilisateurs?
          </strong>
        </p>

        <p>
          Les traitements mis en œuvre par OSTREON reposent sur les bases légales suivantes:
        </p>

        <table className={`${styles.personal_table} ${styles.half_width}`}>
          <tbody>
            <tr>
              <td>
                <strong>
                  Gestion de la relation contractuelle
                </strong>
              </td>
              <td>
                <div>
                  Exécution d’un contrat
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Gestion et réponse aux demandes d’exercice des droits par les personnes concernées
                </strong>
              </td>
              <td>
                <div>
                  Obligation légale
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Gestion des Bénéficiaires
                </strong>
              </td>
              <td rowspan="4">
                Intérêt légitime d’OSTREON
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Envoi de newsletters
                </strong>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Prospection commerciale
                </strong>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Gestion du bon fonctionnement et amélioration du Site et de ses fonctionnalités
                </strong>
              </td>
            </tr>
          </tbody>
        </table>

        <p className={styles.title}>
          <strong>
            6. A qui peuvent être transmises vos Données Personnelles?
          </strong>
        </p>

        <p>
          Vos Données Personnelles sont destinées à un usage au sein de OSTREON et ses collaborateurs, partenaires ou prestataires.
        </p>

        <p>
          OSTREON a recours aux prestataires suivants:
          <ul>
            <li>
              Stripe: gestion de la facturation;
            </li>
            <li>
              Google: Pour l'utilisation des performances et statistiques du site Internet et commerciales, en utilisant l'outil Google Analytics et Google Ads Vos Données Personnelles ne peuvent être cédées ou louées à des tiers.
            </li>
          </ul>
        </p>

        <p>
          OSTREON est susceptible de communiquer certaines des Données Personnelles des Utilisateurs à la demande des autorités judiciaires, policières ou administratives légalement habilitées à en connaître.
        </p>

        <p className={styles.title}>
          <strong>
            7. Combien de temps OSTREON conserve-t-elle vos Données Personnelles?
          </strong>
        </p>

        <p>
          OSTREON conserve les Données Personnelles des Utilisateurs pour une durée strictement nécessaire et proportionnée aux opérations pour lesquelles elles ont été collectées, notamment:
        </p>

        <table className={`${styles.personal_table} ${styles.half_width}`}>
          <tbody>
            <tr>
              <td>
                <strong>
                  Gestion du Compte Utilisateur Gestion des Bénéficiaires
                </strong>
              </td>
              <td>
                <div>
                  Pendant la durée de la relation contractuelle ou pendant la durée du Compte Client
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Fourniture des Services
                </strong>
              </td>
              <td>
                Pendant la durée de la relation contractuelle ou pendant la durée du Compte Client
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Prospection commerciale
                </strong>
              </td>
              <td>
                Jusqu'au retrait du consentement ou trois (3) ans à compter du dernier contact des personnes avec OSTREON
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Envoi de newsletters
                </strong>
              </td>
              <td>
                Jusqu’au retrait du consentement
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Choix en matière de cookies
                </strong>
              </td>
              <td>
                Six (6) mois
              </td>
            </tr>

            <tr>
              <td>
                <strong>
                  Instruction de la demande d’exercice des droits des personnes concernées
                </strong>
              </td>
              <td>
                Pendant la durée de l’instruction
              </td>
            </tr>
          </tbody>
        </table>

        <p>
          Elles sont ensuite archivées pour une durée maximale de cinq (5) ans (à l’exception des données de carte bancaire et du choix en matière de cookies et sous réserve des contraintes règlementaires d’OSTREON), correspondant à la durée de prescription de droit commun pour respecter la loi, anonymisées ou effacées, le cas échéant.
        </p>


        <p className={styles.title}>
          <strong>
            8. Quels sont vos droits?
          </strong>
        </p>

        <p>
          En vertu de la Réglementation applicable en matière de protection des Données Personnelles, vous disposez des droits suivants:
          <ul>
            <li>
              Le droit d’accéder à vos Données Personnelles (article 15 du RGPD);
            </li>
            <li>
              Le droit de rectifier vos Données Personnelles (article 16 RGPD);
            </li>
            <li>
              Le droit de demander l’effacement et la limitation de vos Données Personnelles (article 17 du RGPD);
            </li>
            <li>
              Le droit à la portabilité de vos Données Personnelles (article 20 RGPD);
            </li>
            <li>
              Le droit de s’opposer au traitement de vos Données Personnelles (article 21 RGPD);
            </li>
            <li>
              Le droit de définir les conditions d’utilisation, de conservation et de communication de vos Données Personnelles après votre décès;
            </li>
            <li>
              Introduire une réclamation auprès de l’autorité de contrôle compétente, à savoir la Commission Nationale de l’Informatique et des Libertés (CNIL).
            </li>
          </ul>
        </p>

        <p>
          Vous pouvez exercer vos droits en adressant votre demande, exposant l’objet de cette dernière, par courrier ou email aux coordonnées suivantes:
          <ul>
            <li>
              Par email: <a href="mailto:compliance@ostreon.io">compliance@ostreon.io</a>;
            </li>
            <li>
              Par courrier à l’adresse postale suivante : 13 T rue Auguste Gervais – 92130 Issy-les-Moulineaux, France.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            9. Quelles mesures sont mises en œuvre afin de préserver vos Données Personnelles?
          </strong>
        </p>

        <p>
          OSTREON met en œuvre les mesures techniques et organisationnelles nécessaires à la préservation de la sécurité et de la confidentialité de vos Données Personnelles notamment:
          <ul>
            <li>
              Confiance zéro et connaissance zéro; à l'exception des informations détaillées ci-dessus, OSTREON évite de connaître ou d'être capable de lire toute autre donnée liée au client, en particulier les données successorales et les données d'actifs - celles-ci sont chiffrées avec la clé privée du client sur son navigateur, envoyées et stockées sur les serveurs d'OSTREON sous forme de données chiffrées illisibles. OSTREON n'héberge jamais les clés privées des clients et ne peut jamais lire les informations chiffrées avec celles-ci;
            </li>
            <li>
              Séparation des serveurs pour la facturation et les données successorales, afin de rompre la connexion entre l'identité du client, nécessaire pour la facturation, et les données chiffrées du client liées à ses données successorales;
            </li>
            <li>
              Sécurisation des serveurs avec différentes mesures de sécurité fournies par AWS, y compris contre les tentatives de force brute;
            </li>
            <li>
              Mise en œuvre de Google Captcha v3;
            </li>
            <li>
              Protection du panneau d'administration au sein d'un réseau restreint;
            </li>
            <li>
              Autre mesures.
            </li>
          </ul>
        </p>

        <p className={styles.title}>
          <strong>
            10. Le Site utilise-t-il des cookies?
          </strong>
        </p>

        <p>
          Oui. La navigation sur le Site est susceptible de provoquer l’installation de cookies sur l’ordinateur des Utilisateurs. Les cookies sont des petits fichiers de données textuelles qui peuvent être déposés sur le terminal de l’Utilisateur lors de la visite d'un site afin notamment de rendre plus efficace l'expérience Utilisateur.
        </p>

        <p className={styles.title}>
          <strong>
            La politique Cookies:
          </strong>
        </p>

        <p>
          Nous utilisons des cookies pour améliorer votre expérience de navigation et la sécurité sur Ostreon. En continuant à utiliser Ostreon, vous consentez à l'utilisation de cookies conformément à cette Politique relative aux cookies.
        </p>

        <p>
          Chez Ostreon, nous tenons à vous assurer que nous ne collectons jamais d'informations susceptibles de nous permettre de vous identifier personnellement. Nous respectons votre vie privée et nous efforçons d'assurer une expérience de navigation sécurisée et anonyme.
        </p>

        <p className={styles.title}>
          <strong>
            10.1. Quelles sont les finalités de ces cookies?
          </strong>
        </p>

        <p>
          <strong>Nous utilisons les types de cookies suivants sur Ostreon:</strong>
          <div>
            Les cookies sont de petits fichiers texte stockés sur votre appareil lorsque vous visitez un site web. Ils sont couramment utilisés pour permettre aux sites web de fonctionner plus efficacement, ainsi que pour fournir des informations aux propriétaires du site.
          </div>
        </p>

        <p>
          Les cookies utilisés sur le Site sont:
        </p>

        <p>
          <strong>
            Cookies essentiels:
          </strong>
          ces cookies sont nécessaires au fonctionnement du Site et ne peuvent pas être désactivés dans les systèmes d’OSTREON. Ils sont généralement mis en place en réponse à des actions que l’Utilisateur a effectué, telles que le réglage de ses préférences en matière de confidentialité, l'ouverture d'une session ou le remplissage de formulaires. L’Utilisateur peut configurer son navigateur pour qu'il bloque ces cookies ou l’en avertisse, mais certaines parties du Site risquent de ne pas fonctionner correctement.
        </p>

        <p>
          <strong>
            Cookies analytiques/de performance:
          </strong>
          ces cookies permettent à OSTREON d'analyser la manière dont les visiteurs utilisent OSTREON, afin que cette dernière puisse mesurer et améliorer ses performances. Ces cookies aident OSTREON à comprendre quelles sont les pages les plus et les moins populaires, et à voir comment les Utilisateurs se déplacent sur le Site. Toutes les informations collectées par ces cookies sont agrégées et donc anonymes. Si vous n'autorisez pas ces cookies, nous ne serons pas en mesure de contrôler les performances de notre Site.
        </p>

        <p>
          En acceptant nos cookies, vous acceptez notre Politique de Confidentialité et nos Conditions d'Utilisation, où vous pouvez trouver plus d'informations sur les données que nous collectons et comment nous les utilisons.
        </p>

        <p>
          Vous pouvez gérer vos préférences en matière de cookies à tout moment en ajustant les paramètres de votre navigateur. Veuillez noter que le blocage de certains types de cookies peut affecter votre expérience sur Ostreon.
        </p>

        <p>
          Si vous avez des questions ou des préoccupations concernant notre utilisation des cookies, veuillez nous contacter: <a href="mailto:contact@ostreon.io">contact@ostreon.io</a>.
        </p>

        <p className={styles.title}>
          <strong>
            10.2. Combien de temps sont conservées ces données?
          </strong>
          <p>
            Les informations collectées au travers de ces cookies demeurent disponibles tant que les cookies sont présents sur le terminal, sans pouvoir excéder une durée de treize (13) mois à compter de leur dépôt.
          </p>
        </p>

        <p className={styles.title}>
          <strong>
            10.3. Comment accepter ou refuser les cookies?
          </strong>
        </p>

        <p>
          Lorsque l’Utilisateur accède pour la première fois sur le Site, un bandeau apparaît pour lui fournir des informations sur les cookies utilisés, lui permettre d’accepter ou bien de refuser les cookies.
        </p>

        <p>
          En toute hypothèse, l’Utilisateur conserve le contrôle de ces cookies. L’Utilisateur a la possibilité de modifier ou de retirer son consentement à tout moment, par l’intermédiaire du Site et/ou en paramétrant son navigateur, à l’exception des cookies essentiels nécessaires au fonctionnement du Site.
        </p>

        <p>
          L’Utilisateur peut également modifier ses choix et paramètres à tout moment en paramétrant son navigateur selon les méthodes suivantes: <a href="https://www.cnil.fr/fr/cookies-et-autres-traceurs/comment-se-proteger/maitriser-votre-navigateur">https://www.cnil.fr/fr/cookies-et-autres-traceurs/comment-se-proteger/maitriser-votre-navigateur</a>.
        </p>

        <p className={styles.title}>
          <strong>
            11. Comment pouvez-vous vous désinscrire de la lettre d’information de OSTREON?
          </strong>
        </p>

        <p>
          Pour se désinscrire de la lettre d’information de OSTREON, l’Utilisateur peut cliquer sur le lien « Se désabonner » ( ou, en anglais, « Unsubscribe ») situé en bas de la lettre d’information pour être retiré à tout moment de la liste de diffusion.
        </p>
      </div>
    </>
  );
}